/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Topselleronepic3Inputs */

const id_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlaris di Epic Games Store`)
};

const ms_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual Teratas di Epic Games Store`)
};

const da_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedst sælgende på Epic Games Store`)
};

const de_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meistverkauft im Epic Games Store`)
};

const en_us2_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Seller on the Epic Games Store`)
};

const es_es2_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más vendido en la Epic Games Store`)
};

const es_mx2_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más vendido en la Epic Games Store`)
};

const fil_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakamabenta sa Epic Games Store`)
};

const fr_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleure vente sur l'Epic Games Store`)
};

const it_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più venduto sull'Epic Games Store`)
};

const hu_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legkelendőbb az Epic Games Store-ban`)
};

const nl_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best verkopend in de Epic Games Store`)
};

const no_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest solgte på Epic Games Store`)
};

const pl_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepiej sprzedające się w Epic Games Store`)
};

const pt_br2_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais vendido na Epic Games Store`)
};

const pt_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais vendido na Epic Games Store`)
};

const ro_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cel mai vândut pe Epic Games Store`)
};

const fi_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Myydyin Epic Games Storessa`)
};

const sv_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bästsäljare i Epic Games Store`)
};

const vi_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán chạy nhất trên Epic Games Store`)
};

const tr_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store'da En Çok Satan`)
};

const cs_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejprodávanější na Epic Games Store`)
};

const bg_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-продаван в Epic Games Store`)
};

const ru_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лидер продаж в Epic Games Store`)
};

const uk_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найпродаваніше в Epic Games Store`)
};

const ar_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأكثر مبيعًا في Epic Games Store`)
};

const hi_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store पर टॉप सेलर`)
};

const th_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขายดีที่สุดบน Epic Games Store`)
};

const ja_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store トップセラー`)
};

const zh_cn2_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic游戏商城畅销榜`)
};

const zh_hant1_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic遊戲商城暢銷榜`)
};

const ko_nav_topselleronepic3 = /** @type {(inputs: Nav_Topselleronepic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store 최고 판매`)
};

/**
* | output |
* | --- |
* | "Top Seller on the Epic Games Store" |
*
* @param {Nav_Topselleronepic3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_topselleronepic3 = /** @type {((inputs?: Nav_Topselleronepic3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Topselleronepic3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_topselleronepic3(inputs)
	if (locale === "ms") return ms_nav_topselleronepic3(inputs)
	if (locale === "da") return da_nav_topselleronepic3(inputs)
	if (locale === "de") return de_nav_topselleronepic3(inputs)
	if (locale === "en-US") return en_us2_nav_topselleronepic3(inputs)
	if (locale === "es-ES") return es_es2_nav_topselleronepic3(inputs)
	if (locale === "es-MX") return es_mx2_nav_topselleronepic3(inputs)
	if (locale === "fil") return fil_nav_topselleronepic3(inputs)
	if (locale === "fr") return fr_nav_topselleronepic3(inputs)
	if (locale === "it") return it_nav_topselleronepic3(inputs)
	if (locale === "hu") return hu_nav_topselleronepic3(inputs)
	if (locale === "nl") return nl_nav_topselleronepic3(inputs)
	if (locale === "no") return no_nav_topselleronepic3(inputs)
	if (locale === "pl") return pl_nav_topselleronepic3(inputs)
	if (locale === "pt-BR") return pt_br2_nav_topselleronepic3(inputs)
	if (locale === "pt") return pt_nav_topselleronepic3(inputs)
	if (locale === "ro") return ro_nav_topselleronepic3(inputs)
	if (locale === "fi") return fi_nav_topselleronepic3(inputs)
	if (locale === "sv") return sv_nav_topselleronepic3(inputs)
	if (locale === "vi") return vi_nav_topselleronepic3(inputs)
	if (locale === "tr") return tr_nav_topselleronepic3(inputs)
	if (locale === "cs") return cs_nav_topselleronepic3(inputs)
	if (locale === "bg") return bg_nav_topselleronepic3(inputs)
	if (locale === "ru") return ru_nav_topselleronepic3(inputs)
	if (locale === "uk") return uk_nav_topselleronepic3(inputs)
	if (locale === "ar") return ar_nav_topselleronepic3(inputs)
	if (locale === "hi") return hi_nav_topselleronepic3(inputs)
	if (locale === "th") return th_nav_topselleronepic3(inputs)
	if (locale === "ja") return ja_nav_topselleronepic3(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_topselleronepic3(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_topselleronepic3(inputs)
	return ko_nav_topselleronepic3(inputs)
});
export { nav_topselleronepic3 as "nav.topSellerOnEpic" }